<sbnb-thermostat-setup-success-wrapper>
  <h2 class="mb-10">🎉 We are automating your properties' temperatures</h2>

  <ul class="list">
    <li>
      <strong>Defaults presets are always enabled,</strong>
      ensuring your properties' temperatures are managed automatically.
    </li>
    <li>All new thermostats will automatically scope to these default presets.</li>
    <li>
      You can adjust your default presets or add custom presets at anytime in
      <strong>Devices > Thermostat Presets.</strong>
    </li>
  </ul>

  <div class="flex justify-between mt-8">
    <sbnb-button (click)="onAdvancedSettings()" type="secondary">Advanced Settings</sbnb-button>
    <sbnb-button [routerLink]="['/devices']" [queryParams]="{ tab: 'thermostats' }">View Dashboard</sbnb-button>
  </div>
</sbnb-thermostat-setup-success-wrapper>
